import React from 'react'
import { Link } from 'react-router-dom'

const CardMultiCarroussel = (props) => {

 
 
    return (

        <div className="card m-4 shadow ">

            <Link to={'/artistes/' + props.NameURL} className="text-decoration-none text-dark">

                <div  className="card-img-top"  style={{backgroundImage: `url(${props.imgMulticarr})`, height: 350+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} />
                
                <div className="card-body" style={{ height: 80+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }}>
                    <h5 className="card-title text-center">{props.NameArtist} </h5>
                </div>

            </Link>

        </div>
    )
}





export default CardMultiCarroussel


